<template>
  <a-date-picker 
    :mode="mode" :format="format" :allowClear="false"
    :getCalendarContainer="trigger => trigger.parentElement"
    :value="date" :open="isOpen"
    @change="() => $emit('change', null)"
    @openChange="onOpenChange"
    @panelChange="onPanelChange"
  />
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  name: 'DatePicker',
  props: {
    date: {
      type: Object,
      default: new Date()
    },
    mode: {
      type: String,
      default: 'date'
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    }
  },
  data () {
    return {
      isOpen: false
    }
  },
  methods: {
    onOpenChange(status) {
      if (status) {
        this.isOpen = true
      } else {
        this.isOpen = false
      }
    },
    onPanelChange(value, mode) {
      this.isOpen = false
      this.$emit('change', value)
    }
  }
})
</script>

<style lang="less" scoped>
</style>
